import { render, staticRenderFns } from "./RolesListPage.vue?vue&type=template&id=20e51834&scoped=true&"
import script from "./RolesListPage.vue?vue&type=script&lang=ts&"
export * from "./RolesListPage.vue?vue&type=script&lang=ts&"
import style0 from "./RolesListPage.vue?vue&type=style&index=0&id=20e51834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e51834",
  null
  
)

export default component.exports